import { getApiData, getS3PresignedUrls, postApi } from '../../../lib/restUtils';

const apiUrl = '/api';
// const API_VERSION = 'v2'; // for bender
const API_VERSION = 'v1'; // for dev connectivity

export const apiGetPresignedUrl = (): Promise<string> => {
  const apiURL = `${apiUrl}/${API_VERSION}/regulatoryMatrix`;
  return getS3PresignedUrls(apiURL);
};

export const apiGetVisionCatalogPresignedUrl = (): Promise<{
  status: number;
  results?: {
    'full.zip': string;
    'delta.zip': string;
    'index.html': string;
    catalog_number: string;
  };
}> => {
  const apiURL = `${apiUrl}/${API_VERSION}/contentservice/get_urls`;
  return getApiData<{
    'full.zip': string;
    'delta.zip': string;
    'index.html': string;
    catalog_number: string;
  }>(apiURL);
};

export const apiPostFileDownloadedEvent = (username: string, file: string, unixtime: number) => {
  const url = `${apiUrl}/${API_VERSION}/contentservice/recordkeeping`;
  const body = {
    username,
    file,
    unixtime,
  };
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  return postApi(url, body).catch(() => {});
};
